var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"upgrade-tier-list"},_vm._l((_vm.tiers),function(tier){return _c('li',{staticClass:"upgrade-plan-item"},[_c('upgrade-plan',_vm._b({},'upgrade-plan',{tier, features: _vm.features, view: _vm.view, onSubmit: _vm.onSubmit},false))],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }